import React from "react";
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tooltip,
} from "@chakra-ui/react";
import { ExternalLinkIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { config } from "../../helpers/config";

/**
 * A store is reached through its channel hostname; the subdomain is only the
 * fallback for a tenant whose channels could not be read.
 */
export const storeUrls = (store) => {
  const channels = (store?.channels || []).filter((channel) => channel.hostname);

  if (channels.length) {
    return channels.map((channel) => ({
      label: `${channel.name} (${channel.code})`,
      url: `https://${channel.hostname}`,
      enabled: channel.enabled,
    }));
  }

  if (store?.username) {
    const suffix = config.storakPlusURL || ".storkplus.com";

    return [
      {
        label: "Default storefront",
        url: `https://${store.username}${suffix}`,
        enabled: true,
      },
    ];
  }

  return [];
};

const StoreLinkButton = ({ store, size = "sm" }) => {
  const urls = storeUrls(store);

  if (!urls.length) {
    return (
      <Tooltip label="No channel hostname on this tenant">
        <Button size={size} isDisabled>
          Visit store
        </Button>
      </Tooltip>
    );
  }

  if (urls.length === 1) {
    return (
      <Button
        as="a"
        href={urls[0].url}
        target="_blank"
        rel="noreferrer"
        size={size}
        rightIcon={<ExternalLinkIcon />}
      >
        Visit store
      </Button>
    );
  }

  return (
    <Menu>
      <MenuButton as={Button} size={size} rightIcon={<ChevronDownIcon />}>
        Visit store
      </MenuButton>
      <MenuList>
        {urls.map((entry) => (
          <MenuItem
            key={entry.url}
            as="a"
            href={entry.url}
            target="_blank"
            rel="noreferrer"
          >
            {entry.label}
            {entry.enabled ? "" : " — disabled"}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default StoreLinkButton;
